var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.containerCssClass,on:{"click":_vm.showPaymentForm}},[_c('i',{staticClass:"fas fa-plus fa-2x"}),_vm._v(" "),_c('span',{class:_vm.textCssClass,staticStyle:{"margin-top":"7px"}},[_vm._v("New card")])])}
var staticRenderFns = []

export { render, staticRenderFns }